import i18next from "@/i18n";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import Icon from "@components/atoms/Icon";
import PageTitle from "@components/atoms/PageTitle";
import TabSelector from "@components/atoms/TabSelector";

import { IconName } from "@const/enum";
import { URLS } from "@const/urls";

const SUB_NAVS = [
  {
    title: "Customer Care",
    navs: [
      {
        navTitle: "Customer\nService",
        name: i18next.t("pages.nav.cs"),
        url: URLS.PAGES_CS,
      },
      {
        navTitle: "Shipping\nInformation",
        name: i18next.t("pages.nav.shipping"),
        url: URLS.PAGES_SHIPPING_INFORMATION,
      },
    ],
  },
  {
    title: "Terms",
    navs: [
      {
        navTitle: "Privacy\nPolicy",
        name: i18next.t("pages.nav.privacy_policy"),
        url: URLS.PAGES_PRIVACY_POLICY,
      },
      {
        navTitle: "Terms &\nConditions",
        name: i18next.t("pages.nav.terms_condition"),
        url: URLS.PAGES_TERMS_AND_CONDITIONS,
      },
    ],
  },
];

function SubPages() {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(location.pathname);

  useEffect(() => {
    setCurrentTab(location.pathname);
  }, [location]);

  const handleClick = (url: string) => {
    setCurrentTab(url);
    navigate(url);
  };

  const renderTitle = () => {
    let title = "";

    SUB_NAVS.forEach((item) => {
      item.navs.forEach(({ url, navTitle }) => {
        if (url === currentTab) {
          return (title = navTitle);
        }
      });
    });

    return title;
  };

  return (
    <>
      <PageTitle>{renderTitle()}</PageTitle>
      <ul className="pc:flex col-span-2 hidden flex-col gap-10">
        {SUB_NAVS.map(({ title, navs }) => (
          <li key={title}>
            <div className="mb-5 text-sm uppercase">{title}</div>
            <ul className="flex flex-col gap-2.5">
              {navs.map(({ name, url }) => (
                <TabSelector
                  isAccount
                  isSelected={currentTab === url}
                  key={name}
                  name={name}
                  onClick={() => {
                    handleClick(url);
                  }}
                />
              ))}
            </ul>
          </li>
        ))}
      </ul>
      <Outlet />
    </>
  );
}

export default SubPages;
